/**
 * HTML date input values and API DATE_FROM / DATE_TO (naive local wall clock).
 * Avoid `new Date("YYYY-MM-DD")` — it is UTC in ECMAScript and shifts the calendar day in many zones.
 */

export function parseLocalDateFromYmd(ymd) {
  if (!ymd || typeof ymd !== "string") return null;
  const parts = ymd.split("-");
  if (parts.length !== 3) return null;
  const y = parseInt(parts[0], 10);
  const m = parseInt(parts[1], 10);
  const d = parseInt(parts[2], 10);
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return null;
  const dt = new Date(y, m - 1, d);
  if (Number.isNaN(dt.getTime())) return null;
  return dt;
}

function startOfLocalDay(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
}

function endOfLocalDay(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);
}

function formatLocalApiDateTime(d) {
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  const da = String(d.getDate()).padStart(2, "0");
  const h = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  const s = String(d.getSeconds()).padStart(2, "0");
  const ms = String(d.getMilliseconds()).padStart(3, "0");
  return `${y}-${mo}-${da}T${h}:${mi}:${s}.${ms}`;
}

/**
 * @param {Date|string|null|undefined} value
 * @param {boolean} isEnd - if true, use end of local day (23:59:59.999)
 * @returns {string|null} e.g. "2026-03-28T00:00:00.000"
 */
export function toApiDateParam(value, isEnd = false) {
  if (value == null || value === "") return null;
  let d;
  if (value instanceof Date) {
    d = value;
  } else if (typeof value === "string") {
    const t = value.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(t)) {
      d = parseLocalDateFromYmd(t);
    } else {
      d = new Date(t);
    }
  } else {
    return null;
  }
  if (!d || Number.isNaN(d.getTime())) return null;
  const z = isEnd ? endOfLocalDay(d) : startOfLocalDay(d);
  return formatLocalApiDateTime(z);
}
